/* ============================================================
   Snuggle Dragons — theme.js
   AJAX cart drawer · menu drawer · gallery · sticky header/ATC · qty
   · scent swatches · countdown. Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};
  var freeShip = window.freeShip || { threshold: 0, away: '', unlocked: '' };
  var shopCurrency = window.shopCurrency || 'USD';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency', currency: shopCurrency
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  /* ---------- body scroll lock ---------- */
  var lockedScrollY = 0;
  function lockScroll(on) {
    if (on) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -lockedScrollY + 'px';
      document.body.classList.add('drawer-open');
    } else {
      var de = document.documentElement;
      var prevBehavior = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      document.body.classList.remove('drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
      de.style.scrollBehavior = prevBehavior;
    }
  }

  /* ---------- drawers ---------- */
  var overlay = $('#Overlay');

  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    lockScroll(true);
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawers() {
    $all('.drawer').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    lockScroll(false);
  }

  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  document.addEventListener('click', function (e) {
    var openT = e.target.closest('[data-drawer-open]');
    if (openT) {
      e.preventDefault();
      var target = $('#' + openT.getAttribute('data-drawer-open'));
      if (target && target.id === 'CartDrawer') refreshCart();
      openDrawer(target);
    }
    var closeT = e.target.closest('[data-drawer-close]');
    if (closeT) {
      var isLink = closeT.tagName === 'A' && closeT.getAttribute('href');
      if (!isLink) e.preventDefault();
      closeDrawers();
    }
  });

  /* ---------- cart ---------- */
  var cartDrawer = $('#CartDrawer');
  var cartBody = $('#CartDrawerBody');
  var cartFoot = $('#CartDrawerFoot');

  /* ---------- cart reservation timer (per session, re-arms) ----------
     Starts on the first add-to-cart of the session, persists across page
     loads via sessionStorage, and re-arms when it hits zero so it never
     sits at 0:00. Cleared when the cart goes empty. */
  var cartTimer = (function () {
    var el = $('#CartTimer');
    var KEY = 'mz_cart_reserved_until';
    var valEl = el ? el.querySelector('[data-cart-timer-val]') : null;
    var durationMs = el ? (parseInt(el.getAttribute('data-minutes'), 10) || 5) * 60000 : 300000;
    var interval = null;

    function read() {
      var v;
      try { v = parseInt(sessionStorage.getItem(KEY), 10); } catch (e) {}
      return (v && !isNaN(v)) ? v : 0;
    }
    function write(v) { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} }
    function erase() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

    function render() {
      if (!el) return;
      var until = read();
      if (!until) { hide(); return; }
      var diff = until - Date.now();
      if (diff <= 0) { until = Date.now() + durationMs; write(until); diff = durationMs; }
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (valEl) valEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    function show() {
      if (!el || !read()) return;
      el.hidden = false;
      render();
      if (!interval) interval = setInterval(render, 1000);
    }
    function hide() {
      if (el) el.hidden = true;
      if (interval) { clearInterval(interval); interval = null; }
    }
    return {
      has: function () { return !!read(); },
      start: function () { if (!el) return; if (!read()) write(Date.now() + durationMs); show(); },
      show: show,
      stop: function () { erase(); hide(); }
    };
  })();

  function updateBubble(count) {
    $all('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.classList.toggle('is-visible', count > 0);
    });
  }

  function renderShipBar(cart) {
    var bar = $('#ShipBar');
    if (!bar) return;
    var threshold = parseInt(freeShip.threshold, 10) || 0;
    if (!threshold || !cart.item_count) { bar.hidden = true; bar.innerHTML = ''; return; }
    bar.hidden = false;
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    var text = remaining > 0
      ? (freeShip.away || 'You are __AMOUNT__ away from free shipping').replace('__AMOUNT__', money(remaining))
      : (freeShip.unlocked || 'You have free shipping!');
    bar.innerHTML =
      '<p class="ship-note">' + text + '</p>' +
      '<div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(cart) {
    $all('[data-cart-subtotal]').forEach(function (subtotal) { subtotal.textContent = money(cart.total_price); });
    if (!cartBody) return;
    updateBubble(cart.item_count);
    renderShipBar(cart);
    if (!cart.item_count) { cartTimer.stop(); }
    else if (cartTimer.has()) { cartTimer.show(); }

    cartBody.classList.add('is-fading');

    if (!cart.item_count) {
      cartBody.innerHTML =
        '<div class="cart-empty">' +
        '<p class="h3">' + escapeHtml(cartBody.getAttribute('data-empty') || 'Koszyk jest pusty') + '</p>' +
        '<button class="btn btn--primary" style="margin-top:1.6rem" data-drawer-close>' +
        escapeHtml(cartBody.getAttribute('data-empty-cta') || 'Wybierz kolor') + '</button></div>';
      if (cartFoot) cartFoot.hidden = true;
      requestAnimationFrame(function () { cartBody.classList.remove('is-fading'); });
      return;
    }
    if (cartFoot) cartFoot.hidden = false;

    var removeLabel = escapeHtml(cartBody.getAttribute('data-remove') || 'Usuń');
    var addons = window.themeAddons;
    var kitT = (window.__kit && window.__kit.cfg && window.__kit.cfg.t) || {};
    var html = cart.items.filter(function (item) { return !(addons && addons.isHidden(item)); }).map(function (item) {
      var line = item.key;
      // a card add-on (e.g. the extra bunch) is one per cart, a per-piece one at most one per bunch: no stepper, and its
      // link stays on the store's product
      // (a checkbox add-on and shipping protection are hidden above: cart-addons.js draws them as checkbox rows)
      var isUpsell = !!(addons && addons.isAddon(item) === 'upsell');
      var href = isUpsell ? '/' : item.url;
      var badge = (kitT.gift_badge && kitT.gift_badge_cart !== false && (!kitT.gift_badge_type || item.product_type === kitT.gift_badge_type))
        ? '<div>' + (kitT.gift_badge_html || '<span class="gift-badge">' + escapeHtml(kitT.gift_badge) + '</span>') + '</div>' : '';
      var variant = (item.product_has_only_default_variant) ? '' :
        '<div class="ci-variant">' + escapeHtml(item.options_with_values.map(function (o) { return o.value; }).join(' · ')) + '</div>';
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      // a set's price is a tied offer: the cart names the discount instead of crossing out a price (store kit)
      var isGift = !!(item.properties && item.properties._kit_gift);
      var discHtml = (item.line_level_discount_allocations || []).map(function (a) {
        return '<span class="kit-line-discount">' + escapeHtml((a.discount_application && a.discount_application.title) || '') + ' &minus;' + money(a.amount) + '</span>';
      }).join('');
      var priceHtml = isGift ? escapeHtml((window.__kit && window.__kit.cfg.t && window.__kit.cfg.t.free) || 'Gratis')
        : (item.original_line_price > item.final_line_price)
        ? money(item.final_line_price) + discHtml
        : money(item.final_line_price);
      return '' +
        '<div class="cart-item" data-line="' + line + '">' +
          '<a href="' + escapeHtml(href) + '">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '<span></span>') + '</a>' +
          '<div class="ci-meta">' +
            '<a href="' + escapeHtml(href) + '" class="ci-title">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="ci-price">' + priceHtml + '</div>' +
            (isGift ? '' : badge) +
          '</div>' +
          '<div class="ci-controls">' +
            (isUpsell ? '<span class="cart-item__once">' + item.quantity + '\u00a0' + escapeHtml(kitT.pieces || 'szt.') + '</span>' :
            '<div class="qty">' +
              '<button type="button" data-line-change="' + line + '" data-dir="-1" aria-label="' + escapeHtml(strings.decrease || '-') + '">&minus;</button>' +
              '<input type="text" value="' + item.quantity + '" readonly aria-label="qty">' +
              '<button type="button" data-line-change="' + line + '" data-dir="1" aria-label="' + escapeHtml(strings.increase || '+') + '">+</button>' +
            '</div>') +
            '<button class="ci-remove" data-line-change="' + line + '" data-set="0">' + removeLabel + '</button>' +
          '</div>' +
        '</div>';
    }).join('');
    cartBody.innerHTML = html;
    requestAnimationFrame(function () { cartBody.classList.remove('is-fading'); });

    var sub = $('#CartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
  }

  document.addEventListener('kit:cart', function (event) { renderCart(event.detail); });

  function refreshCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(line, qty) {
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    var line = btn.getAttribute('data-line-change');
    if (btn.disabled) return;
    $all('[data-line-change]').forEach(function (b) { b.disabled = true; });
    function change(quantity) {
      changeLine(line, quantity).catch(function () {
        if (window.themeAddons) window.themeAddons.fail();
      }).finally(function () { $all('[data-line-change]').forEach(function (b) { b.disabled = false; }); });
    }
    var item = btn.closest('.cart-item');
    if (btn.hasAttribute('data-set')) {
      change(parseInt(btn.getAttribute('data-set'), 10));
      return;
    }
    var input = item.querySelector('input');
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(0, current + parseInt(btn.getAttribute('data-dir'), 10));
    change(next);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var fullCart = form.matches('.cart-page__form');
    var checkout = e.submitter && e.submitter.name === 'checkout';
    if (!fullCart && !(checkout && form.closest('#CartDrawer'))) return;
    if (form.dataset.cartSettled === 'true') return;
    e.preventDefault();
    var updates = {};
    if (fullCart) $all('[data-cart-item-key]', form).forEach(function (row) {
      if (!row.hidden) updates[row.dataset.cartItemKey] = Math.max(0, Number(row.querySelector('[name="updates[]"]').value) || 0);
    });
    var body = { updates: updates };
    var note = form.querySelector('[name="note"]');
    if (note) body.note = note.value;
    fetch((routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(function (cart) {
        if (!checkout || !cart.item_count) { location.reload(); return; }
        // Keep Shopify's native checkout submission, without stale updates[] resurrecting removed lines.
        $all('[name="updates[]"]', form).forEach(function (input) { input.disabled = true; });
        form.dataset.cartSettled = 'true';
        e.submitter.disabled = false;
        form.requestSubmit(e.submitter);
      }).catch(function () { if (window.themeAddons) window.themeAddons.fail(); });
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('.cart-line__remove');
    if (!remove) return;
    e.preventDefault();
    var row = remove.closest('[data-cart-item-key]');
    changeLine(row.dataset.cartItemKey, 0).then(function () { location.reload(); })
      .catch(function () { if (window.themeAddons) window.themeAddons.fail(); });
  });

  /* ---------- add-on switches under the offer cards (snippets/product-addons.liquid) ----------
     [data-product-addons] names its product form in data-form; each row is a checkbox [data-product-addon] with its
     variant, its price and whether it goes one per bunch. The ticked ones go into the cart with the product. */
  function addonHost(form) {
    var fid = form.getAttribute('id');
    return fid ? $('[data-product-addons][data-form="' + fid + '"]') : null;
  }
  function tickedAddons(form) {
    var host = addonHost(form);
    return host ? $all('[data-product-addon]', host).filter(function (input) { return input.checked; }) : [];
  }
  // tell the page the switches changed (assets/kit.js redraws the buttons' total)
  function addonsChanged(form) {
    var host = addonHost(form);
    if (host) host.dispatchEvent(new Event('change', { bubbles: true }));
  }
  // the dynamic checkout button submits the form alone and would leave a ticked add-on behind: it hides meanwhile
  document.addEventListener('change', function (e) {
    var host = e.target && e.target.closest && e.target.closest('[data-product-addons]');
    var form = host && document.getElementById(host.getAttribute('data-form'));
    if (form) form.classList.toggle('has-addons', tickedAddons(form).length > 0);
  });

  /* ---------- add to cart (product forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    var status = form.querySelector('[data-form-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.innerHTML = strings.adding || 'Dodaję…'; }

    // a set of 2 or 3 sends each bunch with its own scent (the scent tabs of the variant picker)
    var picks = typeof form.__scentPicks === 'function' ? form.__scentPicks() : null;
    // the ticked add-on switches go in the same request, after the product: one each, or one per bunch of the set
    var ticked = tickedAddons(form);
    var items = picks;
    if (ticked.length) {
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      items = picks ? picks.slice() : [{ id: idField ? idField.value : '', quantity: Math.max(1, parseInt(qtyField ? qtyField.value : '1', 10) || 1) }];
      var setQuantity = items.reduce(function (n, item) { return n + item.quantity; }, 0);
      ticked.forEach(function (input) {
        items.push({
          id: input.getAttribute('data-variant'),
          quantity: input.getAttribute('data-per-piece') === 'true' ? setQuantity : 1,
          properties: { _mz_addon: 'upsell' }
        });
      });
    }
    fetch((routes.cartAdd || '/cart/add') + '.js', items ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    } : {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return refreshCart(); })
      .then(function () {
        // the ticked add-ons are in the cart with the product: their switches go back to off
        if (ticked.length) { ticked.forEach(function (input) { input.checked = false; }); addonsChanged(form); }
        if (btn) { btn.innerHTML = strings.added || 'Dodano'; }
        cartTimer.start();
        openDrawer(cartDrawer);
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = original; }
          // the button's label came back with the total it had when it was pressed
          if (btn && ticked.length) addonsChanged(form);
        }, 1200);
      })
      .catch(function (err) {
        if (status) { status.hidden = false; status.textContent = (err && err.description) || strings.error || 'Something went wrong.'; }
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = original; }
      });
  });

  /* ---------- quick add by variant id ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-variant]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-add-variant');
    var orig = b.innerHTML;
    b.disabled = true; b.innerHTML = strings.adding || 'Dodaję…';
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { cartTimer.start(); openDrawer(cartDrawer); b.disabled = false; b.innerHTML = orig; })
      .catch(function () { b.disabled = false; b.innerHTML = orig; });
  });

  /* ---------- qty steppers ([data-qty] wrapper) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty] button');
    if (!b) return;
    var wrap = b.closest('[data-qty]');
    var input = wrap.querySelector('input');
    if (!input) return;
    var dir = parseInt(b.getAttribute('data-dir'), 10) || 0;
    var min = input.min === '' ? 1 : parseInt(input.min, 10);
    var v = Math.max(min, (parseInt(input.value, 10) || min) + dir);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- sliders ([data-slider]: optional prev/next, dots, autoplay) ---------- */
  var sliderReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $all('[data-slider]').forEach(function (track) {
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var scope = track.parentElement;
    var nav = scope ? scope.querySelector('[data-slider-nav]') : null;
    var prev = nav ? nav.querySelector('[data-slider-prev]') : null;
    var next = nav ? nav.querySelector('[data-slider-next]') : null;
    var dotsWrap = scope ? scope.querySelector('[data-slider-dots]') : null;

    function step() {
      var item = slides[0];
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / step());
    }
    function goTo(i) {
      var clamped = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: step() * clamped, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    if (dotsWrap) {
      var dots = slides.map(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'slider-dot';
        dot.setAttribute('aria-label', (strings.goToSlide || 'Slajd __INDEX__').replace('__INDEX__', i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
        return dot;
      });
      var setActiveDot = function () {
        var idx = currentIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      setActiveDot();
      var dotTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(dotTimer);
        dotTimer = window.setTimeout(setActiveDot, 100);
      }, { passive: true });
    }

    var autoplayMs = parseInt(track.getAttribute('data-slider-autoplay'), 10);
    if (autoplayMs && !sliderReduceMotion) {
      var timer = null;
      var start = function () {
        stop();
        timer = window.setInterval(function () {
          goTo((currentIndex() + 1) % slides.length);
        }, autoplayMs);
      };
      var stop = function () { if (timer) { window.clearInterval(timer); timer = null; } };
      start();
      track.addEventListener('mouseenter', stop);
      track.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start);
    }
  });

  /* ---------- gallery (swipeable track + thumb sync + jump-to-media) ---------- */
  $all('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var slides = track ? $all('[data-gallery-slide]', track) : [];
    var thumbs = $all('[data-thumb]', g);
    if (!track || slides.length < 2) return;

    function setActive(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    function slideLeft(slide) {
      return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }
    function goTo(i) {
      track.scrollTo({ left: slideLeft(slides[i]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      setActive(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var nearest = slides.reduce(function (best, slide, i) {
          return Math.abs(slideLeft(slide) - track.scrollLeft) < Math.abs(slideLeft(slides[best]) - track.scrollLeft) ? i : best;
        }, 0);
        setActive(nearest);
      }, 80);
    }, { passive: true });

    // Let the variant picker jump the gallery to a variant's featured media
    g.addEventListener('gallery:show-media', function (e) {
      var id = e.detail && String(e.detail.mediaId);
      if (!id) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
      if (idx >= 0) goTo(idx);
    });
  });

  /* ---------- animated accordions (<details class="accordion">) ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $all('.accordion').forEach(function (details) {
    var summary = details.querySelector('summary');
    var body = details.querySelector('.accordion__body');
    if (!summary || !body || reduceMotion || !details.animate) return;

    var anim = null;
    var closing = false;
    var expanding = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (closing || !details.open) {
        openAndExpand();
      } else if (expanding || details.open) {
        shrink();
      }
    });

    function shrink() {
      closing = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';
      if (anim) anim.cancel();
      anim = details.animate({ height: [startHeight, endHeight] }, { duration: 220, easing: 'ease-out' });
      body.animate({ opacity: [1, 0] }, { duration: 150, easing: 'ease-out' });
      anim.onfinish = function () { onFinish(false); };
      anim.oncancel = function () { closing = false; };
    }

    function openAndExpand() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(function () { expand(); });
    }

    function expand() {
      expanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + body.offsetHeight + 'px';
      if (anim) anim.cancel();
      anim = details.animate({ height: [startHeight, endHeight] }, { duration: 220, easing: 'ease-out' });
      body.animate({ opacity: [0, 1] }, { duration: 220, easing: 'ease-out' });
      anim.onfinish = function () { onFinish(true); };
      anim.oncancel = function () { expanding = false; };
    }

    function onFinish(open) {
      details.open = open;
      anim = null;
      closing = false;
      expanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  });

  /* ---------- sticky header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('header--scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- sticky add-to-cart ---------- */
  var stickyAtc = $('[data-sticky-atc]');
  var buyAnchor = $('[data-buy-actions]');
  if (stickyAtc && buyAnchor && 'IntersectionObserver' in window) {
    var passedBuy = false;
    var pendingSticky = false;
    function updateSticky() {
      pendingSticky = false;
      var privacyOpen = $all('#shopify-pc__banner, #shopify-pc__prefs, [data-cookie-banner]').some(function (el) {
        return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
      });
      var show = passedBuy && !document.body.classList.contains('drawer-open') && !privacyOpen;
      if (stickyAtc.classList.contains('is-visible') === show) return;
      stickyAtc.classList.toggle('is-visible', show);
      stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyAtc.inert = !show;
    }
    function scheduleSticky() {
      if (!pendingSticky) { pendingSticky = true; requestAnimationFrame(updateSticky); }
    }
    var atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { passedBuy = !entry.isIntersecting && entry.boundingClientRect.top < 0; });
      scheduleSticky();
    }, { threshold: 0 });
    atcIO.observe(buyAnchor);
    new MutationObserver(scheduleSticky).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    document.addEventListener('visitorConsentCollected', scheduleSticky);
    window.addEventListener('resize', scheduleSticky, { passive: true });
  }

  /* ---------- variant picker (select or swatch radios) + offer tiers ---------- */
  function initProduct(root) {
    if (root.__mzProduct) return;
    root.__mzProduct = true;
    var form = root.querySelector('form[data-product-form]');

    // offer tier → set form quantity
    root.querySelectorAll('[data-offer-qty]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('.product__offer').forEach(function (l) { l.classList.remove('is-selected'); });
        var label = radio.closest('.product__offer');
        if (label) label.classList.add('is-selected');
        if (form) {
          var qtyInput = form.querySelector('input[name="quantity"]');
          if (qtyInput) qtyInput.value = radio.value;
        }
      });
    });

    var pickerData = root.querySelector('[data-product-variants]');
    var variants = null;
    try { variants = pickerData ? JSON.parse(pickerData.textContent) : null; } catch (e) {}
    var picker = root.querySelector('[data-variant-picker]');
    if (!variants || !picker || !form) return;

    var groups = $all('[data-option-index]', picker);
    var idInput = form.querySelector('[data-variant-id]');
    var gallery = root.querySelector('[data-gallery]');

    function valueOf(group) {
      if (group.tagName === 'SELECT') return group.value;
      var checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    }

    function apply() {
      var chosen = groups.map(valueOf);
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      groups.forEach(function (group) {
        var label = group.closest('.product__option');
        var out = label ? label.querySelector('[data-option-value-label]') : null;
        if (out) out.textContent = valueOf(group);
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      var buyBtnEl = form.querySelector('[data-buy-button]');
      var buyBtn = form.querySelector('[data-buy-button] .buy-buttons__label');
      if (buyBtnEl) buyBtnEl.disabled = !match.available;
      if (buyBtn) buyBtn.textContent = match.available ? (strings.addToCart || buyBtn.textContent) : (strings.soldOut || buyBtn.textContent);
      $all('[data-sticky-atc] button[type="submit"]', root).forEach(function (b) { b.disabled = !match.available; });
      if (!root.querySelector('[data-kit-offer-group]') && match.featured_image) {
        var photo = root.querySelector('[data-sticky-photo] img');
        if (photo) { photo.removeAttribute('srcset'); photo.src = match.featured_image.src; }
      }
      if (gallery && match.featured_media && match.featured_media.id) {
        gallery.dispatchEvent(new CustomEvent('gallery:show-media', { detail: { mediaId: match.featured_media.id } }));
      }
    }

    function centerSwatch(group, behavior) {
      var checked = group.querySelector('.swatch__input:checked');
      var swatch = checked && checked.closest('.swatch');
      var track = swatch && swatch.closest('.product__swatches');
      if (!track || track.scrollWidth <= track.clientWidth) return;
      track.scrollTo({
        left: track.scrollLeft + swatch.getBoundingClientRect().left - track.getBoundingClientRect().left - (track.clientWidth - swatch.offsetWidth) / 2,
        behavior: behavior
      });
    }
    /* A set of 2 or 3 bunches: a tab per bunch above the swatches, each bunch with its own scent. The swatches
       always show and change the active tab's scent; the form's variant id is the active tab's. Products with one
       option only (the scent). */
    var slotsEl = picker.querySelector('[data-scent-slots]');
    var slotHint = picker.querySelector('[data-scent-hint]');
    var legend = picker.querySelector('[data-scent-legend]');
    var stickyScent = root.querySelector('[data-sticky-scent]');
    var chosenEl = picker.querySelector('[data-scent-chosen]');
    var picks = [];
    var active = 0;
    function byId(id) { return variants.find(function (v) { return String(v.id) === String(id); }); }
    function setQty() {
      var r = root.querySelector('[data-kit-offer]:checked');
      return Math.max(1, r ? (parseInt(r.getAttribute('data-qty'), 10) || 1) : 1);
    }
    function thumb(v) {
      var src = v && v.featured_image && v.featured_image.src;
      return src ? src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=120' : '';
    }
    // the picker's colour look: a scent's colour, carried by its swatch
    function colourOf(v) {
      if (!v || !groups[0] || groups[0].tagName === 'SELECT') return '';
      var radio = $all('input[type="radio"]', groups[0]).find(function (r) { return r.value === v.options[0]; });
      return (radio && radio.getAttribute('data-swatch-colour')) || '';
    }
    function summary() {
      var names = [], counts = {};
      picks.forEach(function (id) { var v = byId(id); if (!v) return; if (!counts[v.title]) { counts[v.title] = 0; names.push(v.title); } counts[v.title]++; });
      return names.map(function (n) { return (counts[n] > 1 ? counts[n] + '\u00d7\u00a0' : '') + n; }).join(' + ');
    }
    function drawSlots() {
      var n = setQty();
      var current = idInput ? String(idInput.value) : null;
      if (!picks.length) picks = [current];
      while (picks.length < n) picks.push(picks[picks.length - 1]);
      picks.length = n;
      if (active >= n) active = n - 1;
      picks[active] = current;
      if (stickyScent) stickyScent.textContent = summary();
      if (chosenEl) {
        var strong = document.createElement('strong'); strong.textContent = summary();
        chosenEl.replaceChildren(document.createTextNode((n > 1 ? chosenEl.getAttribute('data-set') : chosenEl.getAttribute('data-one')) + ': '), strong);
      }
      form.classList.toggle('has-mixed-scents', picks.some(function (id) { return id !== picks[0]; }));
      if (!slotsEl) return;
      var many = n > 1;
      slotsEl.hidden = !many;
      if (slotHint) slotHint.hidden = !many;
      var word = slotsEl.getAttribute('data-label') || '';
      if (legend) legend.textContent = many ? word + ' ' + (active + 1) : legend.getAttribute('data-name');
      slotsEl.replaceChildren();
      if (!many) return;
      picks.forEach(function (id, i) {
        var v = byId(id);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'scent-slot';
        b.setAttribute('data-scent-slot', String(i));
        b.setAttribute('aria-pressed', i === active ? 'true' : 'false');
        var colour = colourOf(v);
        var src = thumb(v);
        if (colour) { var dot = document.createElement('span'); dot.className = 'scent-slot__dot'; dot.style.background = colour; b.appendChild(dot); }
        else if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.width = 36; im.height = 36; b.appendChild(im); }
        var text = document.createElement('span'); text.className = 'scent-slot__text';
        var nEl = document.createElement('span'); nEl.className = 'scent-slot__n'; nEl.textContent = word + ' ' + (i + 1);
        var vEl = document.createElement('span'); vEl.className = 'scent-slot__v'; vEl.textContent = v ? v.title : '';
        text.append(nEl, vEl); b.appendChild(text);
        slotsEl.appendChild(b);
      });
    }
    if (slotsEl) {
      slotsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-scent-slot]');
        if (!b) return;
        active = parseInt(b.getAttribute('data-scent-slot'), 10) || 0;
        // show this bunch's scent on the swatches: check its radio and let the picker apply it
        var v = byId(picks[active]);
        var radio = v && groups[0] && $all('input[type="radio"]', groups[0]).find(function (r) { return r.value === v.options[0]; });
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        else drawSlots();
      });
      // the set changed (offer cards or the sticky bar's chips)
      root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-kit-offer]')) drawSlots(); });
      form.__scentPicks = function () {
        if (setQty() < 2 || picks.length < 2) return null;
        var items = [];
        picks.forEach(function (id) {
          var hit = items.find(function (x) { return x.id === id; });
          if (hit) hit.quantity++; else items.push({ id: id, quantity: 1 });
        });
        return items;
      };
    }

    groups.forEach(function (group) {
      centerSwatch(group, 'instant');
      group.addEventListener('change', function () {
        apply();
        drawSlots();
        centerSwatch(group, reduceMotion ? 'instant' : 'smooth');
      });
    });
    drawSlots();
  }
  $all('.product').forEach(initProduct);
  // the theme editor redraws a section after each change: its picker and scent tabs start again
  document.addEventListener('shopify:section:load', function (e) { $all('.product', e.target).forEach(initProduct); });

  /* ---------- countdown timers ([data-countdown]) ---------- */
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  $all('[data-countdown]').forEach(function (el) {
    // Session mode: the clock starts fresh per browsing session (persisted in
    // sessionStorage) and re-arms when it hits zero, so it never sits dead.
    var sessionKey = el.getAttribute('data-session-key');
    var durationMs = parseInt(el.getAttribute('data-session-ms'), 10) || 0;
    var sessionMode = !!(sessionKey && durationMs > 0);

    function sessionDeadline() {
      var stored;
      try { stored = parseInt(sessionStorage.getItem(sessionKey), 10); } catch (e) {}
      if (!stored || isNaN(stored) || stored <= Date.now()) {
        stored = Date.now() + durationMs;
        try { sessionStorage.setItem(sessionKey, String(stored)); } catch (e) {}
      }
      return stored;
    }

    var deadline;
    if (sessionMode) {
      deadline = sessionDeadline();
    } else {
      var raw = el.getAttribute('data-deadline');
      if (!raw) return;
      deadline = new Date(raw.trim().replace(' ', 'T')).getTime();
      if (isNaN(deadline)) return;
    }
    var expired = el.getAttribute('data-expired') || '';
    var host = el.closest('[data-countdown-host]') || el;
    var dd = el.querySelector('[data-cd="days"]');
    var hh = el.querySelector('[data-cd="hours"]');
    var mm = el.querySelector('[data-cd="mins"]');
    var ss = el.querySelector('[data-cd="secs"]');
    var timer = setInterval(tick, 1000);
    tick();
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        if (sessionMode) {
          deadline = sessionDeadline();  // re-arm for another session-length window
          diff = deadline - Date.now();
        } else {
          clearInterval(timer);
          if (expired) { el.innerHTML = '<span class="cd-expired">' + escapeHtml(expired) + '</span>'; }
          else { host.hidden = true; }
          return;
        }
      }
      if (dd) dd.textContent = pad2(Math.floor(diff / 86400000));
      if (hh) hh.textContent = pad2(Math.floor((diff % 86400000) / 3600000));
      if (mm) mm.textContent = pad2(Math.floor((diff % 3600000) / 60000));
      if (ss) ss.textContent = pad2(Math.floor((diff % 60000) / 1000));
    }
  });

  /* ---------- promo pill link ---------- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-promo-link]');
    if (p) window.location.href = p.getAttribute('data-promo-link');
  });

  /* ---------- reviews wall: load more ---------- */
  $all('[data-reviews-wall]').forEach(function (wall) {
    var btn = wall.parentElement ? wall.parentElement.querySelector('[data-reviews-more]') : null;
    var cards = $all('[data-review-card]', wall);
    var visible = parseInt(wall.getAttribute('data-initial'), 10) || 6;
    var stepN = parseInt(wall.getAttribute('data-step'), 10) || 6;
    function paint() {
      cards.forEach(function (c, i) { c.hidden = i >= visible; });
      if (btn) btn.hidden = visible >= cards.length;
    }
    paint();
    if (btn) btn.addEventListener('click', function () { visible += stepN; paint(); });
  });

  // initial cart bubble
  refreshCart();
})();
